import { render } from "./SJDeliveryRecord.vue?vue&type=template&id=710b3612&scoped=true"
import script from "./SJDeliveryRecord.vue?vue&type=script&lang=js"
export * from "./SJDeliveryRecord.vue?vue&type=script&lang=js"

import "./SJDeliveryRecord.vue?vue&type=style&index=0&id=710b3612&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-710b3612"

export default script